var giphy_viewer_default = {
  "giphyWrapper": "R56vE",
  "giphy_player": "KCyxl",
  "playIcon": "qD1GU",
  "gifRatio": "U-IEa"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
